// 组织结构配置文件
// 您可以在这里修改组织结构和用户数据

/**
 * 组织结构数据配置
 * 数据结构说明：
 * - id: 节点唯一标识符
 * - label: 节点显示名称
 * - children: 子节点数组（可选）
 */
export const orgTreeConfig = [
  {
    id: 'admin',
    label: 'admin',
    children: [
      {
        id: 'admin-1',
        label: '余总',
        children: [
          { id: 'admin-1-1', label: 'wenzong' }
        ]
      },
      {
        id: 'admin-2',
        label: '路通',
        children: [
          { id: 'admin-2-1', label: 'Mia' },
          { id: 'admin-2-2', label: '梦露' },
          { id: 'admin-2-3', label: '梦霞' }
        ]
      },
      {
        id: 'admin-3',
        label: '东泽',
        children: [
          { id: 'admin-3-1', label: 'qing' },
          { id: 'admin-3-2', label: 'xiaomi' }
        ]
      },
      {
        id: 'admin-4',
        label: '深圳总公司',
        children: [
          { id: 'admin-4-1', label: '研发部门' },
          { id: 'admin-4-2', label: 'developer1' },
          { id: 'admin-4-3', label: 'developer2' }
        ]
      }
    ]
  }
];

/**
 * 用户数据配置
 * 字段说明：
 * - userId: 用户编号
 * - userName: 用户名称
 * - userNickname: 用户昵称
 * - dept: 所属部门
 * - phone: 手机号码
 * - currentReceived: 当前收益
 * - totalReceived: 累计收益
 * - growthRate: 收益增长率
 * - createTime: 创建时间
 */
export const userTableConfig = [
  {
    userId: 1,
    userName: 'admin',
    userNickname: '疯狂的狮子Lv',
    dept: '研发部门',
    phone: '15888888888',
    currentReceived: '¥15,600',
    totalReceived: '¥156,000',
    growthRate: '+12.5%',
    createTime: '2025-04-29 17:38:49'
  },
  {
    userId: 21,
    userName: 'wenzong',
    userNickname: 'wenzong',
    dept: '余总',
    phone: '13800138001',
    currentReceived: '¥25,800',
    totalReceived: '¥258,000',
    growthRate: '+22.3%',
    createTime: '2025-04-15 10:20:30'
  },
  {
    userId: 22,
    userName: 'chaoge',
    userNickname: '超哥',
    dept: '余总',
    phone: '13900139002',
    currentReceived: '¥19,200',
    totalReceived: '¥192,000',
    growthRate: '+15.7%',
    createTime: '2025-04-20 14:35:20'
  },
  {
    userId: 31,
    userName: 'Mia',
    userNickname: 'Mia',
    dept: '路通',
    phone: '13700137003',
    currentReceived: '¥9,600',
    totalReceived: '¥96,000',
    growthRate: '-2.1%',
    createTime: '2025-05-21 19:00:58'
  },
  {
    userId: 32,
    userName: 'menglu',
    userNickname: '梦露',
    dept: '路通',
    phone: '13600136004',
    currentReceived: '¥12,400',
    totalReceived: '¥124,000',
    growthRate: '+8.9%',
    createTime: '2025-05-18 16:45:12'
  },
  {
    userId: 33,
    userName: 'mengxia',
    userNickname: '梦霞',
    dept: '路通',
    phone: '13500135005',
    currentReceived: '¥11,800',
    totalReceived: '¥118,000',
    growthRate: '+6.4%',
    createTime: '2025-05-22 11:20:45'
  },
  {
    userId: 41,
    userName: 'qing',
    userNickname: 'qing',
    dept: '东泽',
    phone: '13400134006',
    currentReceived: '¥14,600',
    totalReceived: '¥146,000',
    growthRate: '+12.1%',
    createTime: '2025-05-10 09:30:25'
  },
  {
    userId: 42,
    userName: 'xiaomi',
    userNickname: '小米',
    dept: '东泽',
    phone: '13300133007',
    currentReceived: '¥8,900',
    totalReceived: '¥89,000',
    growthRate: '-3.5%',
    createTime: '2025-05-12 15:40:18'
  },
  {
    userId: 51,
    userName: 'developer1',
    userNickname: '开发工程师1',
    dept: '研发部门',
    phone: '13200132008',
    currentReceived: '¥16,800',
    totalReceived: '¥168,000',
    growthRate: '+18.2%',
    createTime: '2025-04-25 08:15:30'
  },
  {
    userId: 52,
    userName: 'developer2',
    userNickname: '开发工程师2',
    dept: '研发部门',
    phone: '13100131009',
    currentReceived: '¥14,200',
    totalReceived: '¥142,000',
    growthRate: '+9.8%',
    createTime: '2025-04-28 10:25:40'
  }
];

/**
 * 表格列配置
 * 您可以在这里调整表格列的显示、宽度等属性
 */
export const tableColumnConfig = [
  { prop: 'userId', label: '用户编号', width: '100', align: 'center' },
  { prop: 'userName', label: '用户名称', width: '120', align: 'center' },
  { prop: 'userNickname', label: '用户昵称', width: '120', align: 'center' },
  { prop: 'dept', label: '部门', width: '100', align: 'center' },
  { prop: 'phone', label: '手机号码', width: '130', align: 'center' },
  { prop: 'currentReceived', label: '当前收益', width: '120', align: 'center', type: 'currency' },
  { prop: 'totalReceived', label: '累计收益', width: '120', align: 'center', type: 'currency' },
  { prop: 'growthRate', label: '收益增长率', width: '120', align: 'center', type: 'rate' },
  { prop: 'createTime', label: '创建时间', width: '150', align: 'center' }
];

/**
 * 分页配置
 */
export const paginationConfig = {
  pageNum: 1,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100]
};

/**
 * 样式主题配置
 */
export const themeConfig = {
  // 收益相关颜色配置
  colors: {
    positiveGrowth: '#67C23A',  // 正增长颜色（绿色）
    negativeGrowth: '#F56C6C',  // 负增长颜色（红色）
    currentReceived: '#67C23A', // 当前收益颜色
    totalReceived: '#409EFF'    // 累计收益颜色
  },
  // 组织树配置
  tree: {
    nodeHeight: 32,
    selectedColor: '#409eff',
    hoverColor: '#f5f7fa'
  }
};

/**
 * 功能开关配置
 */
export const featureConfig = {
  enableExport: true,        // 是否启用导出功能
  enableMultiSelect: true,   // 是否启用多选功能
  enableTreeSearch: true,    // 是否启用树搜索
  enableAdvancedSearch: true // 是否启用高级搜索
};

// 导出默认配置
export default {
  orgTreeConfig,
  userTableConfig,
  tableColumnConfig,
  paginationConfig,
  themeConfig,
  featureConfig
}; 